export const state = {
  loginFlag: false,
  unauthorizedFlag: false,
  forbiddenFlag: false,
  rateFlag: false,
  loginCompanyId: '',
  loginPassword: '',
  authorization: '',
  header: {
    requestTime: null,
    responseTime: null,
    updatedTime: null,
    userId: '',
    deviceId: 'CareRingsAdmin',
    devicePhysicalId: 'CareRingsAdmin',
    resultCode: 0,
    resultDetailCode: '',
    errorCode: '',
    message: '',
    messageDetail: ''
  },
  loginUser: {},
  masterData: {},
  logoutFlagMaster: {},
  ratesFlagMaster: {},
  passwordEnableFlagMaster: {},
  detailHeaderTitle: [
    {value: '詳細', color: '#BBFFFF', path: '/master/corporations/detail'},
    {value: 'ログ解析', color: '#66FFFF', path: '/master/corporations/logs'},
    {
      value: 'お知らせ',
      color: '#80EBF3',
      path: '/master/corporations/notifications'
    },
    {
      value: 'メンテナンス',
      color: '#C7BFE6',
      path: '/master/corporations/maintenance'
    },
    {
      value: '使用量ログ出力',
      color: '#b0efca',
      path: '/master/corporations/usage'
    }
  ],
  editHeaderTitle: [
    {value: '編集', color: '#BBFFFF', path: '/master/corporations/edit'},
    {value: 'ログ解析', color: '#66FFFF', path: '/master/corporations/logs'},
    {
      value: 'お知らせ',
      color: '#80EBF3',
      path: '/master/corporations/notifications'
    },
    {
      value: 'メンテナンス',
      color: '#C7BFE6',
      path: '/master/corporations/maintenance'
    },
    {
      value: '使用量ログ出力',
      color: '#b0efca',
      path: '/master/corporations/usage'
    }
  ],
  statusData: {},
  browsingAccountFlg: false
}
export const mutations = {
  setMasters(state, response) {
    sessionStorage.setItem('masters', JSON.stringify(response.data['data'][0]))
    state.masterData = Object.assign({}, response.data['data'][0])
    state.logoutFlagMaster = Object.assign({}, response.data['data'][0])
    state.ratesFlagMaster = Object.assign({}, response.data['data'][0])
    state.passwordEnableFlagMaster = Object.assign({}, response.data['data'][0])
  },
  changeAutoLogoutEnableFlag(state, payload) {
    state.logoutFlagMaster.autoLogoutEnableFlag = payload
  },
  changeAutoLogoutSecond(state, payload) {
    state.logoutFlagMaster.autoLogoutSecond = payload
  },
  changeShowRates(state, payload) {
    state.ratesFlagMaster.ratingQuarityEnableFlag = payload
  },
  changeKeyboardType(state, payload) {
    state.masterData.keyboardType = payload
  },
  changePositionJobEnable(state, payload) {
    state.masterData.positionJobEnableFlag = payload
  },
  changeCustomMessageType(state, payload) {
    state.masterData.customMessageType = payload
  },
  setLoginUser(state, payload) {
    state.header.userId = payload.userId
    state.loginCompanyId = payload.companyId
  },
  successLoginFlag(state, response) {
    state.loginUser = response.data['data'][0]
    state.authorization = 'Bearer' + ' ' + response.headers.authorization
    state.header.tenantKey = response.data['header'].tenantKey
    state.loginFlag = true
    // 自動ログアウトしている場合、browsingAccountFlg がfalseになっていないため初期化
    state.browsingAccountFlg = false
    if (state.loginUser.authority === '閲覧ユーザ') {
      state.browsingAccountFlg = true
    }
    sessionStorage.setItem(
      'loginUser',
      JSON.stringify({
        loginUser: response.data['data'][0],
        authorization: 'Bearer' + ' ' + response.headers.authorization,
        tenantKey: response.data['header'].tenantKey,
        userId: state.header.userId,
        companyId: state.loginCompanyId,
        loginFlag: true,
        browsingAccountFlg: state.browsingAccountFlg
      })
    )
  },
  successLogoutFlag(state) {
    sessionStorage.removeItem('masters')
    sessionStorage.removeItem('loginUser')
    state.loginUser = {}
    state.authorization = ''
    state.header.tenantKey = ''
    state.loginFlag = false
    state.browsingAccountFlg = false
  },
  changeUnauthorizedFlag(state) {
    state.unauthorizedFlag = !state.unauthorizedFlag
  },
  changeForbiddenFlag(state) {
    state.forbiddenFlag = !state.forbiddenFlag
  },
  changeRateFlag(state, value) {
    state.rateFlag = value
  },
  clearRateFlag(state) {
    state.rateFlag = false
  },
  setStatus(state, response) {
    state.statusData = Object.assign({}, response.data['data'][0])
  },
  setRestoreMasters(state, payload) {
    state.masterData = Object.assign({}, payload)
    state.logoutFlagMaster = Object.assign({}, payload)
    state.ratesFlagMaster = Object.assign({}, payload)
    state.passwordEnableFlagMaster = Object.assign({}, payload)
  },
  restoreSession(state) {
    const mastersData = sessionStorage.getItem('masters')
    if (mastersData) {
      this.setRestoreMasters(state, JSON.parse(mastersData))
    }
    const loginUserData = sessionStorage.getItem('loginUser')
    if (loginUserData) {
      const loginUserInfo = JSON.parse(loginUserData)
      state.loginUser = loginUserInfo.loginUser
      state.authorization = loginUserInfo.authorization
      state.header.tenantKey = loginUserInfo.tenantKey
      state.loginFlag = loginUserInfo.loginFlag
      state.header.userId = loginUserInfo.userId
      state.loginCompanyId = loginUserInfo.loginCompanyId
      state.browsingAccountFlg = loginUserInfo.browsingAccountFlg
    }
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/masterModules/masterMutation.js